import SitePlace from '../../../api/SitePlace';
import * as types from './mutation-types';

export const getAll = async ({commit}) => {
    const json = await new SitePlace().index();

    commit(types.SITE_PLACES, json);
};

export default {
    getAll,
};



// WEBPACK FOOTER //
// ./src/store/modules/sitePlace/actions.js